<template>
    <v-container fluid grid-list-xs>
        <v-row>
            <v-card tile width="100%" :height="boxHeight" color="black">
                <div class="scroll d-flex flex-column justify-space-around align-center fill-height">
                    <v-img
                        :width="imgWidth"
                        height="auto"
                        :min-width="minImgWidth"
                        :max-width="maxImgWidth"
                        :src="imgSrc"
                        class="transition align-end"
                        v-bind:style="{transform: `rotate(${deg}deg)`}"
                        alt="refresh-icon-btn"
                        ref="imgBox"
                    >
                    </v-img>
                </div>
            </v-card>
            <v-toolbar dark dense>
                <v-spacer></v-spacer>
                <v-toolbar-items class="hidden-sm-and-down">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn text @click="rotateRight" v-on="on">
                                <v-icon color="white">mdi-rotate-right</v-icon>
                            </v-btn>
                        </template>
                        <span>Girar a la derecha</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn text @click="rotateLeft" v-on="on">
                                <v-icon color="white">mdi-rotate-left</v-icon>
                            </v-btn>
                        </template>
                        <span>Girar a la izquierda</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn text @click="zoomIn" v-on="on" :disabled="imgWidth >= maxImgWidth">
                                <v-icon color="white">mdi-magnify-plus-outline</v-icon>
                            </v-btn>
                        </template>
                        <span>Acercar</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn text @click="zoomOut" v-on="on" :disabled="imgWidth <= minImgWidth">
                                <v-icon color="white">mdi-magnify-minus-outline</v-icon>
                            </v-btn>
                        </template>
                        <span>Alejar</span>
                    </v-tooltip>
                </v-toolbar-items>
            </v-toolbar>
        </v-row>
    </v-container>
</template>

<script>

export default {
    name: 'ImgViewer',
    data() {
        return {
            deg: 0,
            minImgWidth: 400,
            maxImgWidth: 1500,
            imgWidth: 400,
            boxHeight: 400,
        }
    },

    props: {
        imgSrc: String,
    },

    mounted() {
        
    },

    created() {
        
    },

    methods: {
        rotateRight() {
            this.deg += 90;
            this.imgWidth = 400;
            if (this.$refs.imgBox.$el.clientWidth > this.$refs.imgBox.$el.clientHeight)
            {
                this.boxHeight = this.$refs.imgBox.$el.clientWidth;
            }
            
            console.log("imgWidth = ", this.imgWidth);
            console.log("imgBox.clientWidth = ", this.$refs.imgBox.$el.clientWidth);
            console.log("imgBox.clientHeight = ", this.$refs.imgBox.$el.clientHeight);
        },
        rotateLeft() {
            this.deg -= 90;
            this.imgWidth = 400;
            if (this.$refs.imgBox.$el.clientWidth > this.$refs.imgBox.$el.clientHeight)
            {
                this.boxHeight = this.imgWidth;
            }
            console.log("imgWidth = ", this.imgWidth);
            console.log("imgBox.clientWidth = ", this.$refs.imgBox.$el.clientWidth);
            console.log("imgBox.clientHeight = ", this.$refs.imgBox.$el.clientHeight);
        },
        zoomIn(){
            this.imgWidth += 50;
            if (this.imgWidth > this.maxImgWidth)
            {
                this.imgWidth = this.maxImgWidth;
            }
            console.log("imgWidth = ", this.imgWidth);
            console.log("imgBox.clientWidth = ", this.$refs.imgBox.$el.clientWidth);
            console.log("imgBox.clientHeight = ", this.$refs.imgBox.$el.clientHeight);
        },
        zoomOut(){
            this.imgWidth -= 50;
            if (this.imgWidth < this.minImgWidth)
            {
                this.imgWidth = this.minImgWidth;
            }
            console.log("imgWidth = ", this.imgWidth);
            console.log("imgBox.clientWidth = ", this.$refs.imgBox.$el.clientWidth);
            console.log("imgBox.clientHeight = ", this.$refs.imgBox.$el.clientHeight);
        }
    },
}

</script>

<style scoped>
.transition {
  transition: transform 0.5s ease-in-out;
}

.scroll {
      overflow-y: auto;
      overflow-x: auto;
    }
</style>